import { forwardRef } from "react"

const GuppieCreativeGrid = forwardRef(function GuppieCreativeGrid({ banner}, ref) {
    if (banner) {
        return <img ref={ref} className="guppie-img" src={banner} />
    } else {
        return null
    }
})

export default GuppieCreativeGrid
